module.exports = __webpack_public_path__ + "media/logos/ft-logo-black-80440ed0.png";